






































import MiniChart from '../components/mini-chart.vue'
import { datetimeOption } from '@/utils/tool'
import { Vue, Component } from 'vue-property-decorator'
import {
  getLast2DaysData,
  getCountDataList,
  getAmountDataList,
  getPayGatePayAmountDataList
} from '@/api/payment/payment'
import MultiDataChart from '../components/multi-data-chart.vue'
const dateArray = datetimeOption('week')

@Component({
  name: 'paymentBoard',
  components: {
    MiniChart,
    MultiDataChart
  }
})
export default class extends Vue {
  chartList: any[] = []

  colors: string[] = ['#fb6260', '#999999', '#0099ff', '#aaaaaa']

  channelNumberData: any = {
    title: '通道数量统计',
    option: {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          label: {
            backgroundColor: '#6a7985'
          }
        }
      },
      legend: {
        data: ['发生数量', '成交数量'],
        icon: 'rect', // 形状  类型包括 circle，rect, line，roundRect，triangle，diamond，pin，arrow，none
        bottom: '10%'
      },
      grid: {
        bottom: '20%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'category',
          boundaryGap: false,
          data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
        }
      ],
      yAxis: [
        {
          type: 'value'
        }
      ],
      series: [
        {
          name: '发生数量',
          type: 'line',
          areaStyle: {},
          color: ['#12a0ff'],
          data: [220, 182, 191, 234, 290, 330, 310]
        },
        {
          name: '成交数量',
          type: 'line',
          areaStyle: {},
          color: ['#ff7b8c'],
          data: [120, 132, 101, 134, 90, 230, 210]
        }
      ]
    }
  }

  orderAmountData: any = {
    title: '成交金额统计',
    option: {
      tooltip: {
        trigger: 'axis'
      },
      grid: { bottom: '20%' },
      legend: {
        data: [],
        icon: 'rect',
        itemHeight: 14,
        itemWidth: 14,
        bottom: '10%'
      },
      calculable: true,
      xAxis: [
        {
          type: 'category',
          data: [
            '1月',
            '2月',
            '3月',
            '4月',
            '5月',
            '6月',
            '7月',
            '8月',
            '9月',
            '10月',
            '11月',
            '12月'
          ]
        }
      ],
      yAxis: [
        {
          type: 'value'
        }
      ],
      series: [
        {
          name: 'PalPal',
          type: 'bar',
          barMaxWidth: '20',
          barGap: '0%',
          data: [2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3],
          color: ['#26a8ff']
        },
        {
          name: 'Alipay',
          type: 'bar',
          barMaxWidth: '20',
          barGap: '0%',
          data: [2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3],
          color: ['#c5e68e']
        },
        {
          name: '总计',
          type: 'bar',
          barMaxWidth: '20',
          barGap: '0%',
          data: [1.3, 5.4, 5.6, 2.6, 5.8, 45.3, 105.6, 162.2, 40.7, 10.8, 2.0, 1.3],
          color: ['#ff8e9d']
        }
      ]
    }
  }

  payChannelData: any = {
    title: '支付通道统计',
    option: {
      tooltip: {
        trigger: 'item'
      },
      title: {
        text: '销售占比',
        left: '60%',
        top: 100
      },
      legend: {
        orient: 'vertical',
        y: 'center',
        icon: 'circle',
        left: '60%'
      },
      series: [
        {
          name: '商品',
          type: 'pie',
          radius: ['25%', '40%'], // 图的大小
          center: ['35%', '50%'], // 图的位置，距离左跟上的位置
          avoidLabelOverlap: false,
          label: {
            normal: {
              show: false,
              position: 'center',
              color: '#4c4a4a',
              formatter: (data: any) => {
                return (
                  '{active|' + ((data.value / 100) * 100).toFixed(2) + '%' + '}' + '\n' + data.name
                )
              },
              rich: {
                total: {
                  fontSize: 35,
                  fontFamily: '微软雅黑',
                  color: '#454c5c'
                },
                active: {
                  fontFamily: '微软雅黑',
                  fontSize: 24,
                  fontWeight: 700,
                  color: '#6c7a89',
                  lineHeight: 30
                }
              }
            },
            emphasis: {
              // 中间文字显示
              show: true
            }
          },
          lableLine: {
            normal: {
              show: false
            },
            emphasis: {
              show: true
            },
            tooltip: {
              show: false
            }
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '40',
              fontWeight: 'bold'
            }
          },
          data: [
            { value: 1048, name: '一年会员' },
            { value: 735, name: '三年会员' },
            { value: 580, name: '半年会员' },
            { value: 484, name: '一年会员（自动续费）' }
          ],
          color: ['#ff7a8c', '#52c1f5', '#8167f5', '#ffa94c']
        }
      ]
    },
    tableData: []
  }

  amountDataParams: any = {
    statType: 'order',
    statDateStart: dateArray[0],
    statDateEnd: dateArray[1]
  }

  channelNumberParams: any = {
    statDateStart: dateArray[0],
    statDateEnd: dateArray[1]
  }

  payChannelParams: any = {
    statDateStart: dateArray[0],
    statDateEnd: dateArray[1]
  }

  init: boolean = false

  async getMiniChartData() {
    const res: any = await getLast2DaysData({
      statType: 'order'
    })
    this.chartList = res.data.dataList.map((item: any) => ({
      type: 'bar',
      title: item.name,
      number: item.number,
      trend: item['link_relative_ratio'] + '%'
    }))
  }

  async getChartData() {
    let allPromise: any[] = [
      getCountDataList(this.channelNumberParams),
      getAmountDataList(this.amountDataParams),
      getPayGatePayAmountDataList(this.payChannelParams)
    ]
    let resArr: any[] = await Promise.all(allPromise)
    let [number, amount, channel] = resArr.map((res: any) => res.data.dataList)
    this.initData({ number, amount, channel })
  }

  async handleDateChange(val: any[], name: string) {
    let [range, callback] = val
    if (range) {
      console.log(range)
      let params = {
        statDateStart: range[0],
        statDateEnd: range[1]
      }
      switch (name) {
        case 'number': {
          this.channelNumberParams = { ...params, statType: 'order' }
          let {
            data: { dataList: number }
          }: any = await getCountDataList(params)
          this.initData({ number })
          break
        }
        case 'amount': {
          this.amountDataParams = params
          let {
            data: { dataList: amount }
          }: any = await getAmountDataList(this.amountDataParams)
          this.initData({ amount })
          break
        }
        case 'channel': {
          this.payChannelParams = params
          let {
            data: { dataList: channel }
          }: any = await getPayGatePayAmountDataList(params)
          this.initData({ channel })
          break
        }
        default:
          break
      }
      callback()
    }
  }

  initData({ number, amount, channel }: any) {
    if (number && number.length > 0) {
      let { option } = this.channelNumberData
      // 这里已经懒得命名了, 浪费脑细胞
      let [x, y, z] = ['stat_date', 'order_count', 'pay_count'].map((field: string) =>
        number.map((item: any) => item[field])
      )
      option.xAxis[0].data = x
      option.series[0].data = y
      option.series[1].data = z
    }
    if (amount && amount.length > 0) {
      let { option } = this.orderAmountData
      const temp: any = amount[0] || {}
      const colorList: string[] = ['#26a8ff', '#c5e68e', '#ff7a8c', '#52c1f5', '#8167f5', '#ffa94c']
      const fields = Object.keys(temp).filter((val) => val !== 'stat_date')
      option.series = Array.from({ length: fields.length + 1 }, (v, i) => ({
        name: '总计',
        type: 'bar',
        barMaxWidth: '20',
        barGap: '0%',
        data: [],
        color: [colorList[i]]
      }))
      option.legend.data = [...fields, '总计']
      let totalData = fields.map((field: string) => amount.map((item: any) => item[field]))
      let xAxisData: any[] = amount.map((item: any) => item['stat_date'])
      option.xAxis[0].data = xAxisData
      for (let i = 0; i < fields.length; i++) {
        option.series[i].data = totalData[i]
        option.series[i].name = fields[i]
      }
      // eslint-disable-next-line
      function sigma(i: number) {
        let sum: number = 0
        for (let data of totalData) {
          sum += data[i]
        }
        return sum
      }
      option.series[fields.length].data = Array.from({ length: totalData[0].length }, (v, i) =>
        sigma(i).toFixed(2)
      ) // 防止精度丢失
    }
    if (channel && channel.length > 0) {
      this.payChannelData.tableData = channel
      let { option } = this.payChannelData
      option.series[0].label.normal.formatter = (data: any) => {
        return (
          '{active|' +
          (
            (data.value /
              (channel.map((item: any) => +item['pay_amount']).reduce((total: number, num: number) => total + num)) * 100 || 0)
          ).toFixed(2) +
          '%' +
          '}' +
          '\n' +
          data.name
        )
      }
      option.series[0].data = channel.map((item: any) => ({
        value: +item['pay_amount'],
        name: item['pay_gate']
      }))
    }
    this.init = true
  }

  created() {
    this.getMiniChartData()
    this.getChartData()
  }
}
